function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import ElForm from 'element-ui/packages/form/src/form.vue'  /* 用于源码调试Element UI */
import emitter from '@/utils/emitter';
import './container-item/index';
import FieldComponents from '@/components/form-designer/form-widget/field-widget/index';
import { generateId, deepClone, getAllContainerWidgets, getAllFieldWidgets, insertCustomCssToHead, insertGlobalFunctionsToHtml, traverseFieldWidgets, buildDefaultFormJson } from '@/utils/util';
import i18n, { changeLocale } from '../../utils/i18n';
export default {
  name: 'VFormRender',
  componentName: 'VFormRender',
  mixins: [emitter, i18n],
  components: _objectSpread({}, FieldComponents),
  props: {
    formJson: {
      //prop传入的表单JSON配置
      type: Object,
      default: function _default() {
        return buildDefaultFormJson();
      }
    },
    formData: {
      //prop传入的表单数据
      type: Object,
      default: function _default() {
        return {};
      }
    },
    optionData: {
      //prop传入的选项数据
      type: Object,
      default: function _default() {
        return {};
      }
    },
    previewState: {
      //是否表单预览状态
      type: Boolean,
      default: false
    },
    globalDsv: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  provide: function provide() {
    var _this = this;
    return {
      refList: this.widgetRefList,
      sfRefList: this.subFormRefList,
      //收集SubForm引用
      formConfig: this.formConfig,
      getGlobalDsv: function getGlobalDsv() {
        return _this.globalDsv;
      },
      // 全局数据源变量
      globalOptionData: this.optionData,
      getOptionData: function getOptionData() {
        return _this.optionData;
      } /* 该方法用于在异步更新option-data之后重新获取到最新值 */,
      globalModel: {
        formModel: this.formDataModel
      },
      previewState: this.previewState,
      getReadMode: function getReadMode() {
        return _this.readModeFlag;
      }
    };
  },
  data: function data() {
    return {
      formJsonObj: this.formJson,
      formDataModel: {
        //
      },
      widgetRefList: {},
      subFormRefList: {},
      formId: null,
      //表单唯一Id，用于区分页面上的多个v-form-render组件！！
      readModeFlag: false,
      externalComponents: {} //外部组件实例集合
    };
  },
  computed: {
    formConfig: function formConfig() {
      if (this.formJsonObj.formConfig) {
        return this.formJsonObj.formConfig;
      }
    },
    widgetList: function widgetList() {
      return this.formJsonObj.widgetList;
    },
    labelPosition: function labelPosition() {
      if (!!this.formConfig && !!this.formConfig.labelPosition) {
        return this.formConfig.labelPosition;
      }
      return 'left';
    },
    labelWidth: function labelWidth() {
      if (!!this.formConfig && !!this.formConfig.labelWidth) {
        return this.formConfig.labelWidth + 'px';
      }
      return '80px';
    },
    size: function size() {
      if (!!this.formConfig && !!this.formConfig.size) {
        return this.formConfig.size;
      }
      return 'medium';
    },
    customClass: function customClass() {
      return !!this.formConfig && !!this.formConfig.customClass ? this.formConfig.customClass : '';
    },
    isReadMode: function isReadMode() {
      return this.getReadMode();
    }
  },
  watch: {
    //
  },
  created: function created() {
    this.buildFormModel(!this.formJsonObj ? null : this.formJsonObj.widgetList);
    this.initFormObject();
  },
  mounted: function mounted() {
    this.initLocale();
    this.handleOnMounted();
  },
  methods: {
    setReadMode: function setReadMode() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      this.readModeFlag = t;
    },
    getReadMode: function getReadMode() {
      return this.readModeFlag;
    },
    initFormObject: function initFormObject() {
      var insertHtmlCodeFlag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.formId = 'vfRender' + generateId();
      if (!!insertHtmlCodeFlag) {
        this.insertCustomStyleAndScriptNode();
      }
      this.addFieldChangeEventHandler();
      this.addFieldValidateEventHandler();
      this.registerFormToRefList();
      this.handleOnCreated();
    },
    getContainerWidgetName: function getContainerWidgetName(widget) {
      if (widget.type === 'grid') {
        //grid-item跟VueGridLayout全局注册组件重名，故特殊处理！！
        return 'vf-grid-item';
      }
      return widget.type + '-item';
    },
    getWidgetName: function getWidgetName(widget) {
      return widget.type + '-widget';
    },
    initLocale: function initLocale() {
      var curLocale = localStorage.getItem('form_cache') || 'zh-CN';
      this.changeLanguage(curLocale);
    },
    insertCustomStyleAndScriptNode: function insertCustomStyleAndScriptNode() {
      if (!!this.formConfig && !!this.formConfig.cssCode) {
        insertCustomCssToHead(this.formConfig.cssCode, !!this.previewState ? '' : this.formId);
      }
      if (!!this.formConfig && !!this.formConfig.functions) {
        insertGlobalFunctionsToHtml(this.formConfig.functions, !!this.previewState ? '' : this.formId);
      }
    },
    buildFormModel: function buildFormModel(widgetList) {
      var _this2 = this;
      if (!!widgetList && widgetList.length > 0) {
        widgetList.forEach(function (wItem) {
          _this2.buildDataFromWidget(wItem);
        });
      }
    },
    buildDataFromWidget: function buildDataFromWidget(wItem) {
      var _this3 = this;
      if (wItem.category === 'container') {
        if (wItem.type === 'grid') {
          if (!!wItem.cols && wItem.cols.length > 0) {
            wItem.cols.forEach(function (childItem) {
              _this3.buildDataFromWidget(childItem);
            });
          }
        } else if (wItem.type === 'table') {
          if (!!wItem.rows && wItem.rows.length > 0) {
            wItem.rows.forEach(function (rowItem) {
              if (!!rowItem.cols && rowItem.cols.length > 0) {
                rowItem.cols.forEach(function (colItem) {
                  _this3.buildDataFromWidget(colItem);
                });
              }
            });
          }
        } else if (wItem.type === 'tab') {
          if (!!wItem.tabs && wItem.tabs.length > 0) {
            wItem.tabs.forEach(function (tabItem) {
              if (!!tabItem.widgetList && tabItem.widgetList.length > 0) {
                tabItem.widgetList.forEach(function (childItem) {
                  _this3.buildDataFromWidget(childItem);
                });
              }
            });
          }
        } else if (wItem.type === 'sub-form') {
          var subFormName = wItem.options.name;
          if (!this.formData.hasOwnProperty(subFormName)) {
            var subFormDataRow = {};
            if (wItem.options.showBlankRow) {
              wItem.widgetList.forEach(function (subFormItem) {
                if (!!subFormItem.formItemFlag) {
                  subFormDataRow[subFormItem.options.name] = subFormItem.options.defaultValue;
                }
              });
              this.$set(this.formDataModel, subFormName, [subFormDataRow]); //
            } else {
              this.$set(this.formDataModel, subFormName, []); //
            }
          } else {
            var initialValue = this.formData[subFormName];
            this.$set(this.formDataModel, subFormName, deepClone(initialValue));
          }
        } else if (wItem.type === 'grid-col' || wItem.type === 'table-cell') {
          if (!!wItem.widgetList && wItem.widgetList.length > 0) {
            wItem.widgetList.forEach(function (childItem) {
              _this3.buildDataFromWidget(childItem);
            });
          }
        } else {
          //自定义容器组件
          if (!!wItem.widgetList && wItem.widgetList.length > 0) {
            wItem.widgetList.forEach(function (childItem) {
              _this3.buildDataFromWidget(childItem);
            });
          }
        }
      } else if (!!wItem.formItemFlag) {
        if (!this.formData.hasOwnProperty(wItem.options.name)) {
          //this.formDataModel[wItem.options.name] = '' //这种写法不支持对象属性响应式更新，必须用$set方法！！
          this.$set(this.formDataModel, wItem.options.name, wItem.options.defaultValue); //设置字段默认值
        } else {
          var _initialValue = this.formData[wItem.options.name];
          this.$set(this.formDataModel, wItem.options.name, deepClone(_initialValue));
        }
      }
    },
    addFieldChangeEventHandler: function addFieldChangeEventHandler() {
      var _this4 = this;
      this.$off('fieldChange'); //移除原有事件监听
      this.$on('fieldChange', function (fieldName, newValue, oldValue, subFormName, subFormRowIndex) {
        _this4.handleFieldDataChange(fieldName, newValue, oldValue, subFormName, subFormRowIndex);
        _this4.$emit('formChange', fieldName, newValue, oldValue, _this4.formDataModel, subFormName, subFormRowIndex);
      });
    },
    addFieldValidateEventHandler: function addFieldValidateEventHandler() {
      var _this5 = this;
      this.$off('fieldValidation'); //移除原有事件监听
      this.$on('fieldValidation', function (fieldName) {
        _this5.$refs.renderForm.validateField(fieldName);
      });
    },
    registerFormToRefList: function registerFormToRefList() {
      this.widgetRefList['v_form_ref'] = this;
    },
    handleFieldDataChange: function handleFieldDataChange(fieldName, newValue, oldValue, subFormName, subFormRowIndex) {
      if (!!this.formConfig && !!this.formConfig.onFormDataChange) {
        var customFunc = new Function('fieldName', 'newValue', 'oldValue', 'formModel', 'subFormName', 'subFormRowIndex', this.formConfig.onFormDataChange);
        customFunc.call(this, fieldName, newValue, oldValue, this.formDataModel, subFormName, subFormRowIndex);
      }
    },
    handleOnCreated: function handleOnCreated() {
      if (!!this.formConfig && !!this.formConfig.onFormCreated) {
        var customFunc = new Function(this.formConfig.onFormCreated);
        customFunc.call(this);
      }
    },
    handleOnMounted: function handleOnMounted() {
      if (!!this.formConfig && !!this.formConfig.onFormMounted) {
        var customFunc = new Function(this.formConfig.onFormMounted);
        customFunc.call(this);
      }
    },
    findWidgetAndSetDisabled: function findWidgetAndSetDisabled(widgetName, disabledFlag) {
      var foundW = this.getWidgetRef(widgetName);
      if (!!foundW) {
        foundW.setDisabled(disabledFlag);
      } else {
        //没找到，可能是子表单中的组件
        this.findWidgetOfSubFormAndSetDisabled(widgetName, disabledFlag);
      }
    },
    findWidgetOfSubFormAndSetDisabled: function findWidgetOfSubFormAndSetDisabled(widgetName, disabledFlag) {
      var _this6 = this;
      this.findWidgetNameInSubForm(widgetName).forEach(function (wn) {
        var sw = _this6.getWidgetRef(wn);
        if (!!sw) {
          sw.setDisabled(disabledFlag);
        }
      });
    },
    findWidgetAndSetHidden: function findWidgetAndSetHidden(widgetName, hiddenFlag) {
      var foundW = this.getWidgetRef(widgetName);
      if (!!foundW) {
        foundW.setHidden(hiddenFlag);
      } else {
        //没找到，可能是子表单中的组件
        this.findWidgetOfSubFormAndSetHidden(widgetName, hiddenFlag);
      }
    },
    findWidgetOfSubFormAndSetHidden: function findWidgetOfSubFormAndSetHidden(widgetName, hiddenFlag) {
      var _this7 = this;
      this.findWidgetNameInSubForm(widgetName).forEach(function (wn) {
        var sw = _this7.getWidgetRef(wn);
        if (!!sw) {
          sw.setHidden(hiddenFlag);
        }
      });
    },
    findWidgetNameInSubForm: function findWidgetNameInSubForm(widgetName) {
      var result = [];
      var subFormName = null;
      var handlerFn = function handlerFn(field, parent) {
        if (!!field.options && field.options.name === widgetName) {
          subFormName = parent.options.name;
        }
      };
      traverseFieldWidgets(this.widgetList, handlerFn);
      if (!!subFormName) {
        var subFormRef = this.getWidgetRef(subFormName);
        if (!!subFormRef) {
          var rowIds = subFormRef.getRowIdData();
          if (!!rowIds && rowIds.length > 0) {
            rowIds.forEach(function (rid) {
              result.push(widgetName + '@row' + rid);
            });
          }
        }
      }
      return result;
    },
    //--------------------- 以下为组件支持外部调用的API方法 begin ------------------//
    /* 提示：用户可自行扩充这些方法！！！ */
    changeLanguage: function changeLanguage(langName) {
      changeLocale(langName);
    },
    getNativeForm: function getNativeForm() {
      //获取原生form引用
      return this.$refs['renderForm'];
    },
    getFormRef: function getFormRef() {
      return this;
    },
    getWidgetRef: function getWidgetRef(widgetName) {
      var showError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var foundRef = this.widgetRefList[widgetName];
      if (!foundRef && !!showError) {
        this.$message.error(this.i18nt('render.hint.refNotFound') + widgetName);
      }
      return foundRef;
    },
    clearFormDataModel: function clearFormDataModel() {
      for (var pkey in this.formDataModel) {
        delete this.formDataModel[pkey];
      }
    },
    /**
     * 动态加载表单JSON
     * @param newFormJson
     */
    setFormJson: function setFormJson(newFormJson) {
      var _this8 = this;
      if (!!newFormJson) {
        if (typeof newFormJson === 'string' || newFormJson.constructor === Object) {
          var newFormJsonObj = null;
          if (typeof newFormJson === 'string') {
            newFormJsonObj = JSON.parse(newFormJson);
          } else {
            newFormJsonObj = newFormJson;
          }
          if (!newFormJsonObj.formConfig || !newFormJsonObj.widgetList) {
            this.$message.error('Invalid format of form json.');
            return;
          }

          /* formDataModel必须在widgetList赋值完成初始化，因为widgetList赋值意味着子组件开始创建！！！ */
          //this.formDataModel = {}  //清空表单数据对象（有bug，会导致表单校验失败！！）
          this.clearFormDataModel(); //上行代码有问题，会导致表单校验失败，故保留原对象引用只清空对象属性！！
          this.buildFormModel(newFormJsonObj.widgetList);
          this.$set(this.formJsonObj, 'formConfig', newFormJsonObj.formConfig);
          this._provided.formConfig = newFormJsonObj.formConfig; //强制更新provide的formConfig对象
          this.$set(this.formJsonObj, 'widgetList', newFormJsonObj.widgetList);
          this.insertCustomStyleAndScriptNode(); /* 必须先插入表单全局函数，否则VForm内部引用全局函数会报错！！！ */
          this.$nextTick(function () {
            _this8.initFormObject(false);
            _this8.handleOnMounted();
          });
        } else {
          this.$message.error('Set form json failed.');
        }
      }
    },
    /**
     * 重新加载选项数据
     * @param widgetNames 指定重新加载的组件名称或组件名数组，不传则重新加载所有选项字段
     */
    reloadOptionData: function reloadOptionData(widgetNames) {
      var eventParams = [];
      if (!!widgetNames && typeof widgetNames === 'string') {
        eventParams = [widgetNames];
      } else if (!!widgetNames && Array.isArray(widgetNames)) {
        eventParams = _toConsumableArray(widgetNames);
      }
      this.broadcast('FieldWidget', 'reloadOptionItems', [eventParams]);
    },
    getFormData: function getFormData() {
      var _this9 = this;
      var needValidation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var callback = function nullFunc() {};
      var promise = new window.Promise(function (resolve, reject) {
        callback = function callback(formData, error) {
          !error ? resolve(formData) : reject(error);
        };
      });
      if (!needValidation) {
        callback(this.formDataModel);
        return promise;
      }
      this.$refs['renderForm'].validate(function (valid) {
        if (valid) {
          callback(_this9.formDataModel);
        } else {
          callback(_this9.formDataModel, _this9.i18nt('render.hint.validationFailed'));
        }
      });
      return promise;
    },
    setFormData: function setFormData(formData) {
      var _this10 = this;
      //设置表单数据
      Object.keys(this.formDataModel).forEach(function (propName) {
        if (!!formData && formData.hasOwnProperty(propName)) {
          _this10.formDataModel[propName] = deepClone(formData[propName]);
        }
      });

      // 通知SubForm组件：表单数据更新事件！！
      this.broadcast('ContainerItem', 'setFormData', this.formDataModel);
      // 通知FieldWidget组件：表单数据更新事件！！
      this.broadcast('FieldWidget', 'setFormData', this.formDataModel);
    },
    getFieldValue: function getFieldValue(fieldName) {
      var _this11 = this;
      //单个字段获取值
      var fieldRef = this.getWidgetRef(fieldName);
      if (!!fieldRef && !!fieldRef.getValue) {
        return fieldRef.getValue();
      }
      if (!fieldRef) {
        //如果是子表单字段
        var result = [];
        this.findWidgetNameInSubForm(fieldName).forEach(function (wn) {
          var sw = _this11.getWidgetRef(wn);
          if (!!sw && !!sw.getValue) {
            result.push(sw.getValue());
          }
        });
        return result;
      }
    },
    setFieldValue: function setFieldValue(fieldName, fieldValue) {
      var _this12 = this;
      //单个更新字段值
      var fieldRef = this.getWidgetRef(fieldName);
      if (!!fieldRef && !!fieldRef.setValue) {
        fieldRef.setValue(fieldValue);
      }
      if (!fieldRef) {
        //如果是子表单字段
        this.findWidgetNameInSubForm(fieldName).forEach(function (wn) {
          var sw = _this12.getWidgetRef(wn);
          if (!!sw && !!sw.setValue) {
            sw.setValue(fieldValue);
          }
        });
      }
    },
    getSubFormValues: function getSubFormValues(subFormName) {
      var needValidation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var foundSFRef = this.subFormRefList[subFormName];
      return foundSFRef.getSubFormValues(needValidation);
    },
    setSubFormValues: function setSubFormValues(subFormName, subFormValues) {
      //TODO: 待实现！！
    },
    disableForm: function disableForm() {
      var _this13 = this;
      var wNameList = Object.keys(this.widgetRefList);
      wNameList.forEach(function (wName) {
        var foundW = _this13.getWidgetRef(wName);
        if (!!foundW) {
          if (!!foundW.widget && foundW.widget.type === 'sub-form') {
            foundW.disableSubForm();
          } else {
            !!foundW.setDisabled && foundW.setDisabled(true);
          }
        }
      });
    },
    enableForm: function enableForm() {
      var _this14 = this;
      var wNameList = Object.keys(this.widgetRefList);
      wNameList.forEach(function (wName) {
        var foundW = _this14.getWidgetRef(wName);
        if (!!foundW) {
          if (!!foundW.widget && foundW.widget.type === 'sub-form') {
            foundW.enableSubForm();
          } else {
            !!foundW.setDisabled && foundW.setDisabled(false);
          }
        }
      });
    },
    resetForm: function resetForm() {
      var _this15 = this;
      //重置表单
      var subFormNames = Object.keys(this.subFormRefList);
      subFormNames.forEach(function (sfName) {
        if (!!_this15.subFormRefList[sfName].resetSubForm) {
          _this15.subFormRefList[sfName].resetSubForm();
        }
      });
      var wNameList = Object.keys(this.widgetRefList);
      wNameList.forEach(function (wName) {
        // console.log(wName, 'this.widgetRefList[wName]')
        var foundW = _this15.getWidgetRef(wName);
        if (foundW.fileList && foundW.fileList.length) {
          foundW.resetField();
        }
        if (!!foundW && !foundW.subFormItemFlag && !!foundW.resetField) {
          // 跳过子表单字段！！
          foundW.resetField();
        }
      });
      this.$nextTick(function () {
        _this15.clearValidate(); /* 清除resetField方法触发的校验错误提示 */
      });
    },
    clearValidate: function clearValidate(props) {
      this.$refs.renderForm.clearValidate(props);
    },
    /**
     * 校验表单
     * @param callback 回调函数
     */
    validateForm: function validateForm(callback) {
      this.$refs['renderForm'].validate(function (valid) {
        callback(valid);
      });
    },
    validateFields: function validateFields() {
      //
    },
    disableWidgets: function disableWidgets(widgetNames) {
      var _this16 = this;
      if (!!widgetNames) {
        if (typeof widgetNames === 'string') {
          this.findWidgetAndSetDisabled(widgetNames, true);
        } else if (Array.isArray(widgetNames)) {
          widgetNames.forEach(function (wn) {
            _this16.findWidgetAndSetDisabled(wn, true);
          });
        }
      }
    },
    enableWidgets: function enableWidgets(widgetNames) {
      var _this17 = this;
      if (!!widgetNames) {
        if (typeof widgetNames === 'string') {
          this.findWidgetAndSetDisabled(widgetNames, false);
        } else if (Array.isArray(widgetNames)) {
          widgetNames.forEach(function (wn) {
            _this17.findWidgetAndSetDisabled(wn, false);
          });
        }
      }
    },
    hideWidgets: function hideWidgets(widgetNames) {
      var _this18 = this;
      if (!!widgetNames) {
        if (typeof widgetNames === 'string') {
          this.findWidgetAndSetHidden(widgetNames, true);
        } else if (Array.isArray(widgetNames)) {
          widgetNames.forEach(function (wn) {
            _this18.findWidgetAndSetHidden(wn, true);
          });
        }
      }
    },
    showWidgets: function showWidgets(widgetNames) {
      var _this19 = this;
      if (!!widgetNames) {
        if (typeof widgetNames === 'string') {
          this.findWidgetAndSetHidden(widgetNames, false);
        } else if (Array.isArray(widgetNames)) {
          widgetNames.forEach(function (wn) {
            _this19.findWidgetAndSetHidden(wn, false);
          });
        }
      }
    },
    /**
     * 获取所有字段组件
     * @returns {*[]}
     */
    getFieldWidgets: function getFieldWidgets() {
      var widgetList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return !!widgetList ? getAllFieldWidgets(widgetList) : getAllFieldWidgets(this.formJsonObj.widgetList);
    },
    /**
     * 获取所有容器组件
     * @returns {*[]}
     */
    getContainerWidgets: function getContainerWidgets() {
      var widgetList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return !!widgetList ? getAllContainerWidgets(widgetList) : getAllContainerWidgets(this.formJsonObj.widgetList);
    },
    /**
     * 增加外部组件引用，可通过getEC()方法获取外部组件，以便在VForm内部调用外部组件方法
     * @param componentName 外部组件名称
     * @param externalComponent 外部组件实例
     */
    addEC: function addEC(componentName, externalComponent) {
      this.externalComponents[componentName] = externalComponent;
    },
    /**
     * 判断外部组件是否可获取
     * @param componentName 外部组件名称
     * @returns {boolean}
     */
    hasEC: function hasEC(componentName) {
      return this.externalComponents.hasOwnProperty(componentName);
    },
    /**
     * 获取外部组件实例
     * @param componentName
     * @returns {*}
     */
    getEC: function getEC(componentName) {
      return this.externalComponents[componentName];
    },
    /**
     * 获取globalDsv对象
     * @returns {*}
     */
    getGlobalDsv: function getGlobalDsv() {
      return this.globalDsv;
    } //--------------------- 以上为组件支持外部调用的API方法 end ------------------//
  }
};